import React, {Component} from 'react';
import PropTypes from "prop-types";
import InputField from "./InputField";

class PagingContainer extends Component {

    static propTypes = {
        items: PropTypes.number.isRequired,
        changePage: PropTypes.func.isRequired
    };

    static defaultProps = {
        currentPage: 0,
        itemsPerPage: 50,
    };

    constructor(props) {

        super(props);

        this.state = {
            items: props.items,
            minPages: 0,
            maxPages: (props.items > 0 && props.itemsPerPage > 0) ? Math.ceil(props.items / props.itemsPerPage) : 1
        };

        this.nextPage = this.nextPage.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.setPage = this.setPage.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.items !== this.state.items || nextProps.itemsPerPage !== this.state.itemsPerPage) {
            this.setState({
                items: nextProps.items,
                maxPages: (nextProps.items > 0 && nextProps.itemsPerPage > 0) ? Math.ceil(nextProps.items / nextProps.itemsPerPage) : 1
            });
        }

    }

    nextPage() {

        this.setPage(this.props.currentPage + 1);

    }

    prevPage() {

        this.setPage(this.props.currentPage - 1);

    }

    setPage(pageNumber) {

        let currentPage = pageNumber;

        if (pageNumber < this.state.minPages) currentPage = this.state.maxPages - 1;
        if (pageNumber > this.state.maxPages - 1) currentPage = this.state.minPages;

        if (this.props.changePage) this.props.changePage(currentPage);

    }

    render() {

        if (this.state.items === 0 || this.state.maxPages === 1) return null;

        const pageInfo = (this.props.currentPage + 1) + ' / ' + this.state.maxPages;

        return (
            <div className="pagingBlock bottomLinks clearfix formSettings">
                <button className="prevButton" onClick={this.prevPage}>&nbsp;</button>

                <InputField name={'paging'} value={pageInfo} disabled={true}/>

                <button className="nextButton" onClick={this.nextPage}>&nbsp;</button>
            </div>
        );

    }

}

export default PagingContainer;